<template>
    <div>
        <el-col :span="span">
            <div class="grid-content bg-purple outBox">
                <div class="onePart">
                    <div class="leftBox">
                        <div class="numTitle noWrap">
                            <slot name="numTitle" class="noWrap"></slot>
                            <slot name="time" class="numTitle"  v-if="type!=='timeCenter'"></slot>
                        </div>
                    </div>
                    <div v-if="type==='timeCenter'" class="timeText timePart" >
                        <slot name="time"></slot>
                    </div>
                </div>
                <div class="numOutBox">
                    <div class="numBox">
                             <span class="indexNum marginRight">
                            <!--<slot name="num"></slot>-->
                                     {{showDataCom(total)}}
                        </span>
                        <span class="unit">
                                  <span v-if="isShowUnit">万</span>
                            <slot name="unit"></slot>
                        </span>
                    </div>
                </div>

                <div class="twoPart" v-if="threePartType==='platform'">
                    <div class="item noWrap">
                        <span class="littleTitle itemTitle">极光TV</span>
                        <span class="minFontNum">
                            {{showDataCom(jg)}}
                        </span>
                    </div>
                    <div class="item noWrap">
                        <span class="littleTitle itemTitle">风霆迅</span>
                        <span class="minFontNum">
                         {{showDataCom(ftx)}}
                        </span>
                    </div>
                    <div class="item noWrap">
                        <span class="littleTitle itemTitle">爱奇艺</span>
                        <span class="minFontNum">
                             {{showDataCom(aqy)}}
                        </span>
                    </div>
                </div>
                <div class="twoPart" v-if="threePartType==='setAccount'">
                    <div class="item">
                        <span class="timeText itemTitle">已结算</span>
                        <span class="minFontNum">
                            {{showDataCom(jg)}}
                        </span>
                    </div>
                    <div class="item">
                        <span class="timeText itemTitle">未结算</span>
                        <span class="minFontNum">
                            {{showDataCom(ftx)}}
                        </span>
                    </div>
                    <div class="item">
                        <span class="timeText itemTitle">可结算</span>
                        <span class="minFontNum">
                            {{showDataCom(aqy)}}
                        </span>
                    </div>
                </div>
            </div>
        </el-col>
    </div>
</template>

<script>
    // greenColor orangeColor blueColor   redColor
    export default {
        name: "QuarterRow",
        props:{
            span:{
                default:6
            },
            type:{
                default:'timeRight'
            },
            threePartType:{
                default:'platform'
            },
            color:{},
            iconShow:{
                default:false
            },
            parShowDate:{},
            parShowUnit:{},
            total:{},
            jg:{},
            ftx:{},
            aqy:{},
            alreadySettle:{},
            noSettle:{},
            allowSettle:{},


        },
        data: () => ({
            isShowUnit:false,
        }),
        computed:{
            showDataCom(){
                return function(s,type='',n=2){
                    var stringNum=String(s);
                    var pointIndex=stringNum.indexOf('.');
                    var strLength=0;
                    var result=0;
                    if(pointIndex!==-1){  //有小数点
                        var noPointStr=String(s).substring(0,pointIndex);
                        strLength=noPointStr.length;
                    }else{
                        strLength=stringNum.length;
                    }
                    if(s===null){
                        return 0;
                    }else{
                        if(strLength>5){
                            this.isShowUnit=true;
                            if(type==='money'){
                                result = Math.floor((s /10000) * 100) / 100; //保留小数点两位
                                return result;
                            }else{
                                result = parseInt((s /10000) * 100 / 100); //取整
                                return parseFloat(String(result)).toLocaleString();

                            }
                        }else{   //小于5
                            this.isShowUnit=false;
                            if(type==='money'){
                                n = n > 0 && n <= 20 ? n : 2;
                                s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
                                var l = s.split(".")[0].split("").reverse(), r = s.split(".")[1];
                                var t = "";
                                for (var i = 0; i < l.length; i++) {
                                    t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
                                }
                                return t.split("").reverse().join("") + "." + r;
                            }else{
                                return parseFloat(s).toLocaleString();
                            }
                        }
                    }
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .el-col-5{
        width:20%!important;
    }
    .el-row {
        margin-top: 20px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .borderBox.rowBox .grid-content{
        /*border:1px solid #ddd;*/
    }

    .vertical{
        .grid-content{
            height:100%;
            display:flex;
            flex-direction: column;
            justify-content: space-between;
            .numTitle{
                margin-bottom:20px;
                display:flex;
                justify-content: space-between;
                color:#a3a7af;
            }
            .num{
                font-size:24px;
                margin-right:10px;
            }
        }
        .bg-purple {
            /*background: #d3dce6;*/
            background: #fff;
        }
        .grid-content {
            border-radius: 4px;
            padding:20px 20px;
        }
    }
    .indexIcon{
        font-size:40px;
    }
    .indexIcon.green{
        color:#40c2ad;
    }
    .indexIcon.orange{
        color:#ff9846;
    }
    .indexIcon.blue{
        color:#445eee;
    }
    .indexIcon.red{
        color:#f12525;
    }
    .numBox{
        display:flex;
        align-items: flex-end;
    }
    .indexNum.marginRight{
        margin-right:10px;

    }
    .unit{
        margin-bottom:5px;
    }
    .bottomBox{
        display:flex;
        justify-content: space-between;
    }
    .outBox{
        box-shadow:0 0 11px 2px rgba(94,151,255,0.15);
    }
    .timeText{
        margin-left:-5px;
        font-size:12px;
        color:#a3a7af;
    }
    .onePart{
        display:flex;
        justify-content: space-between;
        /*margin-bottom:10px!important;*/
        /*margin-bottom:35px!important;*/
    }
    .twoPart{
        display:flex;
        justify-content: space-between;
    }
    .itemTitle{
        margin-right:6px;
    }
    .vertical .grid-content .numTitle{
        margin-bottom:0!important;
    }
    .leftBox{
        display:flex;
        align-items: center;
    }
    .littleTitle{
        margin-bottom:20px;
        font-size:12px;
        color:#a3a7af;
    }
    .noWrap{
        white-space: nowrap!important;
    }
    .numOutBox{
        padding:20px 0;
    }




</style>
